import toast from './toast/toast.js'
import dialog from './dialog/dialog'

export default {
  install(Vue) {
    Vue.use(dialog)
    Vue.use(toast)
  }
}